/* eslint-disable no-unused-vars */
export enum ReferralTypeEnum {
  Initial = "INITIAL",
  Milestone = "MILESTONE",
}
